import { Navigate, useOutletContext } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { EmployeePerformancePageDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import type { RouteContext } from 'modules/employees/lib/types'
import Page from 'modules/layout/components/Page'
import PageLoading from 'modules/layout/components/Page/Loading'
import TargetProcessesOverviewTable from 'modules/performance_v2/components/TargetProcessesOverviewTable'
import EmployeesCollectionsBootstrap from 'modules/performance_v2/lib/EmployeesCollectionsBootstrap'

type RootPage = 'employee' | 'profile'
type Props = {
  rootPage: RootPage
}

const EmployeePerformancePage = ({ rootPage }: Props) => {
  const { navigation } = useNavigation()
  const { employee } = useOutletContext<RouteContext>()

  const { loading, data } = useQuery(EmployeePerformancePageDocument, {
    variables: { id: Number(employee.id) },
  })
  const currentEmployee = data?.employees.employee
  const canSeePerformance = currentEmployee?._policies?.seeEmployeePerformanceTab.can ?? false

  if (loading) {
    return (
      <Box width="full" height="full" justifyContent="center" alignItems="center">
        <PageLoading />
      </Box>
    )
  }

  const navigateBack: Record<RootPage, string> = {
    employee: navigation.employees.id.fullPath({ id: String(employee.id) }),
    profile: navigation.profile.fullPath(),
  }

  if (!canSeePerformance) return <Navigate replace to={navigateBack[rootPage]} />

  return (
    <EmployeesCollectionsBootstrap>
      <Page.Body>
        <TargetProcessesOverviewTable accessId={employee.attributes.access_id} />
      </Page.Body>
    </EmployeesCollectionsBootstrap>
  )
}

export default EmployeePerformancePage
